import { Pipe, PipeTransform } from '@angular/core';
import { Subscription } from '@dch/products-business-logic';

@Pipe({
  name: 'fullControl',
})
export class FullControlFilterPipe implements PipeTransform {
  transform(value: any, filter: any): any {
    if (filter) {
      return value
        ? Object.values(value).filter(
            (v: Subscription) => v.family === 'Full Control',
          )
        : [];
    } else {
      return value
        ? Object.values(value).filter(
            (v: Subscription) => v.family !== 'Full Control',
          )
        : [];
    }
  }
}
